import {Injectable} from '@angular/core';

import {BehaviorSubject, filter, map, Observable, switchMap, take, tap} from 'rxjs';

import {WebAccessService} from '../web.access/web-access.service';

import {EventListFilterRequest, IEventResponse} from '../../models/remote.request/EventListFilterRequest';
import {BusinessEvent} from '../../models/domain/BusinessEvent';

import {AuthenticationService} from "@shared/services/authentication/authentication.service";

@Injectable()
export class EventService {

    private eventListAlarmSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private eventListFuelSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private eventListAreaSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]);


    private filterRequestSubject: BehaviorSubject<EventListFilterRequest> = new BehaviorSubject<EventListFilterRequest>(<EventListFilterRequest>{});

    constructor(
        private $webAccess: WebAccessService,
        private authenticationService: AuthenticationService,
    ) {
      if (this.authenticationService.isLoggedByToken)
        return;

      this.authenticationService.isAuthenticated$.pipe(take(1)).subscribe(isAuthenticated => {
        if (isAuthenticated)
          this.initialize();
      });
    }

    private initialize() {
      // Build event list stream
      this.filterRequestSubject.pipe(
        filter(f => f ? true : false),
        switchMap(filter => this.$webAccess.GetEventListByFilter(filter)),
        tap(o => {
          o.Result.forEach(element => {

            // uzupelnienie danych

            // przygotowanie danych z uslugi
            element.EL.Lt = ((element.EL.Lt || '').replace(',', '.'));
            element.EL.Ln = ((element.EL.Ln || '').replace(',', '.'));
          });
        }))
        .subscribe(response => {

          const r = { eventType: response.EventType, events: response.Result as BusinessEvent[] };

          switch (response.EventType) {
            case 0:
              this.eventListAlarmSubject.next(r);
              break;
            case 1:
              this.eventListFuelSubject.next(r);
              break;
            case 2:
              this.eventListAreaSubject.next(r);
              break;
          }

        });
    }

    public getEventListAlarm$(): Observable<any> {
        return this.eventListAlarmSubject.asObservable();
    }

    public getEventListFuel$(): Observable<any> {
        return this.eventListFuelSubject.asObservable();
    }

    public getEventListArea$(): Observable<any> {
        return this.eventListAreaSubject.asObservable();
    }


    public getEventFilterRequest$(): Observable<EventListFilterRequest> {
        return this.filterRequestSubject.asObservable();
    }

    public filterEventList(filter: EventListFilterRequest): void {
        switch (filter.EventType) {
            case 0:
                this.eventListAlarmSubject.next(null);
                break;
            case 1:
                this.eventListFuelSubject.next(null);
                break;
            case 2:
                this.eventListAreaSubject.next(null);
                break;
        }

        this.filterRequestSubject.next(filter);
    }

    public findEvent(filter: EventListFilterRequest): Observable<IEventResponse> {
        return this.$webAccess.GetEventListByFilter(filter).pipe(map(
            response => <any>{ eventType: response.EventType, events: response.Result as BusinessEvent[] }
        ));
    }

    public getEventDetails(eventId: number): Observable<BusinessEvent> {
        return this.$webAccess.GetEventDetails(eventId).pipe(map(
            event => <BusinessEvent>{}
        ));
    }

    public resetEventNotification(): Observable<void> {
        return this.$webAccess.ResetEventNotification().pipe(map(
            response => response.Result
        ));
    }


    public getEventActionForAlarm(): Observable<any> {
        return this.$webAccess.GetEventActionList(0).pipe(map(
            response => response.Result
        ));
    }
}
